import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useVisitTracking } from "../../context/VisitTrackingContext";

/**
 * Tracks current route for timeline: page enter/leave (time spent) and document clicks.
 * Renders nothing.
 */
const PAGE_LOAD_MEASURE_DELAY_MS = 400;

const VisitTracker = () => {
  const location = useLocation();
  const { trackPageEnter, trackPageLeave, trackClick, recordPageLoadTime } = useVisitTracking();

  useEffect(() => {
    const path = location.pathname + (location.search || "");
    trackPageEnter(path);
    return () => {
      trackPageLeave();
    };
  }, [location.pathname, location.search, trackPageEnter, trackPageLeave]);

  // Record page load time after route has had time to render (so Load column shows a value)
  useEffect(() => {
    const id = setTimeout(recordPageLoadTime, PAGE_LOAD_MEASURE_DELAY_MS);
    return () => clearTimeout(id);
  }, [location.pathname, location.search, recordPageLoadTime]);

  useEffect(() => {
    const handleClick = () => trackClick();
    document.addEventListener("click", handleClick, true);
    return () => document.removeEventListener("click", handleClick, true);
  }, [trackClick]);

  return null;
};

export default VisitTracker;
